/**
 * Tonnie Brand Colors
 *
 * Reference: Tonnie Brand Guide v2.5
 */

/**
 * TONNIE PURPLE 01 - Primary
 * Logo, H1, primary buttons, main icons
 */
export const TONNIE_PURPLE_01 = {
  hex: '#5937AF',
  oklch: 'oklch(0.45 0.18 290)',
  rgb: 'rgb(89, 55, 175)',
};

/**
 * TONNIE PURPLE 02 - Light
 * Backgrounds, cards, highlight panels, gradients
 */
export const TONNIE_PURPLE_02 = {
  hex: '#F5F3FA',
  oklch: 'oklch(0.96 0.01 290)',
  rgb: 'rgb(245, 243, 250)',
};

/**
 * TONNIE PURPLE 03 - Dark
 * Headings on light background, emphasis text, borders
 */
export const TONNIE_PURPLE_03 = {
  hex: '#3D2A7A',
  oklch: 'oklch(0.35 0.18 290)',
  rgb: 'rgb(61, 42, 122)',
};

/**
 * ACCENT GREEN / TEAL
 * Success states, approval badges, some CTAs
 */
export const ACCENT_GREEN = {
  hex: '#10B981',
  oklch: 'oklch(0.65 0.18 150)',
  rgb: 'rgb(16, 185, 129)',
};

/**
 * ACCENT ORANGE
 * Energy, highlights (limited usage)
 */
export const ACCENT_ORANGE = {
  hex: '#F59E0B',
  oklch: 'oklch(0.75 0.18 70)',
  rgb: 'rgb(245, 158, 11)',
};

/**
 * Brand color palette object
 */
export const BRAND_COLORS = {
  primary: TONNIE_PURPLE_01,
  secondary: TONNIE_PURPLE_02,
  dark: TONNIE_PURPLE_03,
  success: ACCENT_GREEN,
  warning: ACCENT_ORANGE,
};

/**
 * CSS Custom Properties for brand colors
 */
export const BRAND_CSS_VARS = `
  /* Brand Color System - Tonnie Brand Guide Compliance */
  /* TONNIE PURPLE 01 - Primary (Logo, H1, primary buttons, main icons) */
  --tonnie-purple-01: oklch(0.45 0.18 290);
  /* TONNIE PURPLE 02 - Light (Backgrounds, cards, highlight panels, gradients) */
  --tonnie-purple-02: oklch(0.96 0.01 290);
  /* TONNIE PURPLE 03 - Dark (Headings on light background, emphasis text, borders) */
  --tonnie-purple-03: oklch(0.35 0.18 290);
  /* ACCENT GREEN / TEAL - Success states, approval badges, some CTAs */
  --accent-green: oklch(0.65 0.18 150);
  /* ACCENT ORANGE - Energy, highlights (limited usage) */
  --accent-orange: oklch(0.75 0.18 70);

  /* Primary using brand purple */
  --primary: var(--tonnie-purple-01);
  --primary-foreground: oklch(1 0 0);
`;

/**
 * Semantic color mappings
 */
export const SEMANTIC_COLORS = {
  background: '#F9FAFB', // Soft neutral
  foreground: '#1F2937', // Dark gray
  card: '#FFFFFF',
  cardForeground: '#1F2937',
  muted: '#F3F4F6',
  mutedForeground: '#6B7280',
  border: '#E5E7EB',
  input: '#E5E7EB',
  ring: TONNIE_PURPLE_01.hex,
};
